import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

axios.defaults.withCredentials = true;

/**
 * Handles the Emergent-managed Google auth callback. Extracts `session_id`
 * from the URL fragment, exchanges it with the backend for a session cookie,
 * then redirects to the admin page.
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate('/admin/onboarding', { replace: true });
      return;
    }

    axios
      .post(`${API_BASE}/auth/session`, { session_id: sessionId })
      .then(() => {
        // Clear the hash from the URL for cleanliness.
        window.history.replaceState(null, '', '/admin/onboarding');
        navigate('/admin/onboarding', { replace: true });
      })
      .catch(() => {
        navigate('/admin/onboarding', { replace: true });
      });
  }, [location.hash, navigate]);

  return (
    <main className="min-h-[70vh] flex items-center justify-center">
      <div className="flex items-center gap-3 text-sm" style={{ color: '#3b3656' }}>
        <Loader2 size={18} className="animate-spin" /> Signing you in…
      </div>
    </main>
  );
}
